import type { ErrorCopy } from '@shared/errors/catalog';

/**
 * The `AUTH_*` codes only the account surfaces meet. Codes more than one feature
 * meets live in `@shared/errors/catalog.ts`.
 *
 * **Never inline a backend code in JSX.** The code is a log key; what reaches
 * the operator is the sentence, and the `X-Request-ID` is what they quote.
 *
 * `AUTH_ROLE_REQUIRED` is the sharpest of the four. It is an RBAC miss on the
 * operation rather than an ownership miss, and this console reaches it in one
 * real case: an `operator` opening the roster can read it and cannot block from
 * it, because architecture §6 reserves block, role grant, entitlement grant, and
 * configuration for `admin`. The copy names the next step — find someone who
 * holds it — rather than the refusal.
 */
export const errors: Readonly<Record<string, ErrorCopy>> = {
  AUTH_ROLE_REQUIRED: {
    message: 'حظر الحسابات ورفع الحظر عنها من صلاحية المدير. راجع مسؤولاً لإجرائه.',
    tone: 'warning',
  },
  AUTH_NOT_FOUND: {
    message: 'لم نعثر على هذا الحساب. قد يكون حُذف بينما كانت الصفحة مفتوحة.',
    tone: 'warning',
  },
  AUTH_FILTER_COLUMN_NOT_ALLOWED: {
    message: 'تعذّر ترشيح القائمة بهذه القيمة. اختر دوراً من القائمة ثمّ أعد المحاولة.',
    tone: 'warning',
  },
  AUTH_UPSTREAM_FAILED: {
    message: 'الخدمة غير متاحة الآن. أعد المحاولة بعد قليل.',
    tone: 'neutral',
  },
};
